import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Landing from './pages/Landing';
import Shop from './pages/Shop';
import Product from './pages/Product';
import Checkout from './pages/Checkout';
import { CartProvider } from './contexts/CartContext';
import OrderSuccess from './pages/OrderSuccess';
import TrackOrder from './pages/TrackOrder';
import Register from './pages/Register';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import Account from './pages/Account';


function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={ <Navigate to="/shop" /> }
            />
            <Route
              path="/shop"
              element={
                  <Shop />
              }
            />
            <Route
              path="/shop/:slug/"
              element={
                <Product />
              }
            />
            <Route
              path="/checkout"
              element={
                <Checkout />
              }
            />
            <Route
              path="/order-success/:order/"
              element={
                <OrderSuccess />
              }
            />
            <Route
              path="/track/"
              element={
                <TrackOrder />
              }
            />
            <Route
              path="/track/:order"
              element={
                <TrackOrder />
              }
            />
            <Route
              path="/register"
              element={
                <Register />
              }
            />
            <Route
              path="/login"
              element={
                <Login />
              }
            />
            <Route
              path="/account"
              element={
                <Account />
              }
            />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
